export const infoText = {
  title: "Important Information",
  points: [
    "All officer name lists are directly linked to the SASP Roster. This means your name will only appear if you're listed in the SASP Roster.",
    "When you click \"Copy Report\", it will immediately count as an MDT created and will be added to the Leaderboard. Do not exploit this by spamming the button."
  ]
}; 
